import { render, staticRenderFns } from "./ProcessRequest.vue?vue&type=template&id=60d0ffb8&scoped=true&"
import script from "./ProcessRequest.vue?vue&type=script&lang=js&"
export * from "./ProcessRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0ffb8",
  null
  
)

export default component.exports